import React, { useEffect, useState } from 'react';

import { Box } from '@mui/material';

import { styles } from './styles';
import StoryTellerInput from '@components/pages/private/StoryTellerPage/StoryTellerInput';
import { useDispatch, useSelector } from 'react-redux';
import {
  getIsChatInStory,
  getIsFetchingStoryMessages,
  getIsStoryFetching,
  getProgressChatId,
  getStoriesMessages,
} from '@bus/storyTeller/selectors';
import StoriesList from '@components/pages/private/StoryTellerPage/StoriesList';
import { storyTellerActions } from '@bus/storyTeller/actions';
import EmptyList from '@components/pages/private/StoryTellerPage/EmptyList';
import { useParams } from 'react-router-dom';

const StoryTellerPage: React.FC = () => {
  const dispatch = useDispatch();
  const isStoriesFetching = useSelector(getIsStoryFetching);
  const { storyId } = useParams();
  const messages = useSelector(getStoriesMessages(storyId));
  const isChatInStory = useSelector(getIsChatInStory(storyId));
  const [currentChatId, setCurrentChatId] = useState('');
  const progressId = useSelector(getProgressChatId);
  const isFetchingStoryMessages = useSelector(getIsFetchingStoryMessages);

  useEffect(() => {
    dispatch(storyTellerActions.fetchRatioList());
  }, []);

  useEffect(() => {
    storyId && setCurrentChatId(storyId);
  }, [storyId]);

  useEffect(() => {
    if (!isStoriesFetching && messages === null && isChatInStory) {
      dispatch(
        storyTellerActions.fetchStoryMessages({
          chatId: storyId ? +storyId : 0,
        }),
      );
    }
  }, [storyId, isStoriesFetching, isChatInStory]);

  return (
    <Box sx={styles.root}>
      {messages?.results.length ? (
        <StoriesList
          stories={messages.results[messages.results.length - 1]}
          currentChatId={+currentChatId}
        />
      ) : (
        <EmptyList />
      )}
      {isFetchingStoryMessages &&
        (progressId.includes(+currentChatId) || !messages?.results.length) && (
          <StoryTellerInput
            currentChatId={currentChatId}
            isChatInStory={isChatInStory}
            isCreateNewChat={false}
          />
        )}
    </Box>
  );
};

export default StoryTellerPage;
